import _typeof from "@babel/runtime/helpers/typeof";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { z } from 'zod';
export var ConfigError = /*#__PURE__*/function (ConfigError) {
  ConfigError["NotFound"] = "not_found";
  ConfigError["InvalidState"] = "state_invalid";
  ConfigError["IncorrectType"] = "incorrect_type";
  return ConfigError;
}({});
export var StandardConfigSchema = z.record(z.string(), z.object({
  value: z.union([z.boolean(), z.string(), z.number(), z.string().array(), z.number().array()])
}));
export var MinimalConfigSchema = z.tuple([
// list of boolean configs which are on
z.string().array(),
// list of string config tuples
z.array(z.string()).refine(function (arr) {
  return arr.length % 2 === 0;
}),
// list of number config tuples
z.array(z.union([z.string(), z.number()])).refine(function (arr) {
  if (arr.length % 2 !== 0) {
    return false;
  }
  for (var i = 0; i < arr.length; i += 2) {
    if (typeof arr[i] !== 'string') {
      return false;
    }
    if (typeof arr[i + 1] !== 'number') {
      return false;
    }
  }
  return true;
}),
// list of string list config tuples
z.array(z.union([z.string(), z.string().array()])).refine(function (arr) {
  if (arr.length % 2 !== 0) {
    return false;
  }
  for (var i = 0; i < arr.length; i += 2) {
    var key = arr[i];
    var val = arr[i + 1];
    if (typeof key !== 'string') {
      return false;
    }
    if (!Array.isArray(val) || !val.every(function (x) {
      return typeof x === 'string';
    })) {
      return false;
    }
  }
  return true;
}),
// list of number list config tuples
z.array(z.union([z.string(), z.number().array()])).refine(function (arr) {
  if (arr.length % 2 !== 0) {
    return false;
  }
  for (var i = 0; i < arr.length; i += 2) {
    var key = arr[i];
    var val = arr[i + 1];
    if (typeof key !== 'string') {
      return false;
    }
    if (!Array.isArray(val) || !val.every(function (x) {
      return typeof x === 'number';
    })) {
      return false;
    }
  }
  return true;
})]);
export var AnyConfigSchema = z.union([StandardConfigSchema, MinimalConfigSchema]);
export var ConfigMapSchema = z.map(z.string(), z.object({
  value: z.union([z.boolean(), z.string(), z.number(), z.string().array(), z.number().array()])
}));
function pairs(arr, fn) {
  for (var i = 0; i < arr.length; i += 2) {
    var key = arr[i];
    var val = arr[i + 1];
    if (typeof key !== 'string') {
      throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
    }
    fn(key, val);
  }
}
export function minimalToMap(minimal) {
  var map = new Map();
  minimal[0].forEach(function (boolean) {
    return map.set(boolean, {
      value: true
    });
  });
  pairs(minimal[1], function (a, b) {
    return map.set(a, {
      value: b
    });
  });
  pairs(minimal[2], function (a, b) {
    return map.set(a, {
      value: b
    });
  });
  pairs(minimal[3], function (a, b) {
    return map.set(a, {
      value: b
    });
  });
  pairs(minimal[4], function (a, b) {
    return map.set(a, {
      value: b
    });
  });
  return map;
}
export function standardToMap(standard) {
  var map = new Map();
  Object.entries(standard).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return map.set(key, value);
  });
  return map;
}
export function mapToMinimal(map) {
  var minimal = [[], [], [], [], []];
  var _iterator = _createForOfIteratorHelper(map.entries()),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        value = _step$value[1].value;
      switch (_typeof(value)) {
        case 'boolean':
          if (value) {
            minimal[0].push(key);
          }
          break;
        case 'string':
          minimal[1].push(key, value);
          break;
        case 'number':
          minimal[2].push(key, value);
          break;
        default:
          if (!Array.isArray(value)) {
            throw new Error("Unexpected configuration value: ".concat(value));
          }
          var allStrings = value.every(function (x) {
            return typeof x === 'string';
          });
          if (allStrings) {
            minimal[3].push(key, value);
            break;
          }
          var allNumbers = value.every(function (x) {
            return typeof x === 'number';
          });
          if (allNumbers) {
            minimal[4].push(key, value);
            break;
          }
          throw new Error("Unexpected configuration value: ".concat(value));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return minimal;
}
export function mapToStandard(map) {
  return Object.fromEntries(map.entries());
}